import { render, staticRenderFns } from "./Klienti.vue?vue&type=template&id=42dfedc2&scoped=true&"
import script from "./Klienti.vue?vue&type=script&lang=js&"
export * from "./Klienti.vue?vue&type=script&lang=js&"
import style0 from "./Klienti.vue?vue&type=style&index=0&id=42dfedc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42dfedc2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\4g22\\themes\\foreground-theme-2022\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42dfedc2')) {
      api.createRecord('42dfedc2', component.options)
    } else {
      api.reload('42dfedc2', component.options)
    }
    module.hot.accept("./Klienti.vue?vue&type=template&id=42dfedc2&scoped=true&", function () {
      api.rerender('42dfedc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Klienti.vue"
export default component.exports